import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center gap-1 text-sm flex-wrap sm:flex-nowrap" }

import { useI18n } from 'vue-i18n';
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from '@/constants/EXTERNAL_LINKS';
import ExternalLink from '@/components/ExternalLink.vue';
import { ref } from 'vue';
import { useLocalStorage } from '@/composables/useLocalStorage';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAgreement',
  props: {
    asText: { type: Boolean }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onChange', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const { t } = useI18n();
const { getItem, setItem } = useLocalStorage();
const isAccept = ref(!!getItem('agreement'));

const onChangeAccept = event => {
  isAccept.value = event;
  setItem('agreement', (event ? '1' : '').toString());
  emits('onChange', event);
};

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex align-items-center gap-2", __props.asText ? '' : 'panel-surface'])
  }, [
    _createVNode(_component_Checkbox, {
      modelValue: isAccept.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAccept).value = $event)),
      binary: true,
      class: "ml",
      onInput: onChangeAccept
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('userAgreement.iAccept')), 1),
      _createVNode(ExternalLink, {
        label: _unref(t)('userAgreement.termsOfService'),
        url: _unref(TERMS_OF_SERVICE),
        "not-icon": "",
        color: "secondary"
      }, null, 8, ["label", "url"]),
      _createElementVNode("span", null, _toDisplayString(_unref(t)('userAgreement.and')), 1),
      _createVNode(ExternalLink, {
        label: _unref(t)('userAgreement.privacyPolicy'),
        url: _unref(PRIVACY_POLICY),
        "not-icon": "",
        color: "secondary"
      }, null, 8, ["label", "url"])
    ])
  ], 2))
}
}

})